import React, { useLayoutEffect, useRef, useState } from "react";
import { Container, Row, Card, Spinner } from "react-bootstrap";
import { useSiteContext } from "./Providers/SSCProvider";
import "./css/SiteCircuitManagement.css";
import styles from "../generic/css/Table.module.css";
import { MapProvider } from "./Providers/MapProvider";
import SearchMap from "./SiteSearchMap/SearchMap";
import SiteSearch from "./SiteSearch";
import NewStructuresDisplay from "./NewStructuresDisplay";

import "./css/CircuitStyle.css";

const SSCIndex = () => {
  const headerRef = useRef(null);
  const { isLoading, selectedSite } = useSiteContext();
  const [headerHeight, setHeaderHeight] = useState(0);

  useLayoutEffect(() => {
    if (!headerRef.current) return;
    const el = headerRef.current;
    const update = () => setHeaderHeight(el.getBoundingClientRect().height);
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <>
      {isLoading && (
        <div className={styles["overlay"]}>
          <Spinner animation="border" variant="secondary" />
        </div>
      )}
      <Container fluid className="contentContainer">
        <Row className="justify-content-center">
          <Card
            ref={headerRef}
            className={`sticky-header shadow-sm mb-5 ${
              selectedSite ? "has-site" : "no-site"
            }`}
            style={{ minHeight: "142px" }}
          >
            <MapProvider>
              <SiteSearch />
              <Row>
                {!selectedSite && (
                  <div style={{ paddingTop: "5vh" }}>
                    <SearchMap />
                  </div>
                )}
              </Row>
            </MapProvider>
          </Card>
        </Row>
        {selectedSite && (
          <Row>
            <NewStructuresDisplay headerOffset={headerHeight} />
          </Row>
        )}
      </Container>
    </>
  );
};

export default SSCIndex;
